import React, { useState } from "react";

import { Input, Popover } from "antd";

const { TextArea } = Input;

const PremiumModal = ({ premium, handleOnClickValidateReject, isModalVisible }) => {
  const [isPopOverOpen, setIsPopOverOpen] = useState(false);
  const [rejectComment, setRejectComment] = useState("");

  const popOverContent = (
    <div className="w-96 p-2">
      <div className="flex flex-col my-4">
        <span className="mb-4 mx-2 font-bold">Commentaire :</span>
        <TextArea rows={4} value={rejectComment} onChange={e => setRejectComment(e.target.value)} />
      </div>

      <div
        className="mt-8 flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
        onClick={() => {
          setIsPopOverOpen(false);
          handleOnClickValidateReject(premium._id, "reject", rejectComment);
        }}
      >
        Rejeter la prime
      </div>
    </div>
  );

  const getStatusStyle = status => {
    if (status.id === 1) return "text-gray-500";
    if (status.id === 2) return "text-green-400";
    if (status.id === 3) return "text-red-400";
    if (status.id === 4) return "text-red-700";
  };

  return (
    <div>
      {premium && (
        <div className="py-6">
          <div className="flex justify-between">
            <div>
              <div className="mb-2">
                <span className="mx-2 font-bold">{`Nom : `}</span>
                <span>{premium.user_fullname} </span>
              </div>
              <div className="mb-4">
                <span className="mx-2 font-bold">{`Type de prime : `}</span>
                <div className="mt-2 ml-2 inline-flex"> {premium.type_label} </div>
              </div>
              <div className="my-4">
                <span className="my-1 mx-2 font-bold">{`Montant : `}</span>
                <span>{`${premium.amount !== null ? premium.amount : "N/C"} €`} </span>
              </div>
              <div className="my-4">
                <span className="my-1 mx-2 font-bold">{`Traiter par: `}</span>
                <span> {premium.created_by && premium.created_by.user_fullname} </span>
              </div>
              <div className="my-4">
                <span className="my-1 mx-2 font-bold">{`Motif: `}</span>
                <span> {premium.comment} </span>
              </div>
            </div>
            <div>
              <div className="flex items-center my-4">
                <span className="my-1 mx-2 font-bold">{`Statut: `}</span>
                <div className={`font-bold ${premium.status && getStatusStyle(premium.status)}`}>
                  {" "}
                  {premium.status && premium.status.label}{" "}
                </div>
              </div>
              <div
                className="flex justify-center cursor-pointer mb-2 px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
                onClick={() => handleOnClickValidateReject(premium._id, "validate")}
              >
                {premium.status && premium.status.id === 1 && "Valider"}
              </div>
              <Popover visible={isPopOverOpen && isModalVisible} placement="right" content={popOverContent}>
                <div
                  onClick={() => setIsPopOverOpen(true)}
                  className="flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
                >
                  {premium.status && premium.status.id === 1 && "Rejeter"}
                </div>
              </Popover>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PremiumModal;



// WEBPACK FOOTER //
// src/containers/admin/premium/PremiumModal.js